var _line, _line2, _line3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevelLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 39,
    viewBox: "0 0 65 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 33.0001,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 0 0)",
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 33.0001,
    y2: -0.5,
    transform: "matrix(1 0 0 -1 31.9997 27)",
    stroke: "#97A6C8"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 27,
    y2: -0.5,
    transform: "matrix(-4.37116e-08 1 1 4.37113e-08 33.0001 1)",
    stroke: "#97A6C8",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8043_80305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5831 32.2917L51.3748 27.5L46.5831 22.7083V32.2917Z",
    fill: "#97A6C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8043_80305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23.0001,
    fill: "white",
    transform: "matrix(0 -1 -1 0 59.9998 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelLow);
export default __webpack_public_path__ + "static/media/level-low.1174222e6f307b535d258d0f89281309.svg";
export { ForwardRef as ReactComponent };